import { TVEpisodeInfo } from './CommonTypes';

export type EpgChannel = {
    id: string;
    name: string;
    logo?: string;
    number?: number;
    subscription: boolean;
    favorite: boolean;
    isHd: boolean;
};

export type EpgProgram = TVEpisodeInfo & {
    id: string;
    channelId?: any;
    isChannelReplayCapable: boolean;
    isChannelSubscribed: boolean;
    title: string;
    image?: string;
    startTime: number;
    endTime: number;
    realStartTime: number;
    realEndTime: number;
    start?: number;
    duration?: number;
    isBreak: boolean;
    landscapeImage: string;
    description?: string;
    episodeTitle?: string;
    seasonNumber?: number | null;
    episodeNumber?: number | null;
    genres?: string[];
    releaseYear?: number;
    countries?: string[];
};

export type epgMode = 'Live' | 'Catch-up' | 'Future';

export enum ChannelFilterOptionsValue {
    ALL = 'all',
    ENTITLED = 'subscription',
    FAVORITE = 'favorite',
}
